import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CONTRACT_PRIORITY } from '../utils/contractUtils';

const CONTRACT_LABELS = {
  'hvac-maintenance': 'In-Suite',
  'mechanical-room': 'Mechanical Room',
  'dryer-vent': 'Dryer Vents',
  'stack-cleaning': 'Stack Cleaning',
};

const COLORS = ['#007bff', '#28a745', '#fd7e14', '#6f42c1'];

function ContractTypeDistribution({ buildingsData }) {
  // Aggregate contract type counts
  const data = useMemo(() => {
    const counts = {};
    
    // First, collect all unique contract types from the data
    if (Array.isArray(buildingsData)) {
      buildingsData.forEach(b => {
        if (Array.isArray(b.contracts)) {
          b.contracts.forEach(type => {
            if (type) {
              counts[type] = (counts[type] || 0) + 1;
            }
          });
        }
      });
    }
    
    // Convert to chart data format
    const chartData = Object.entries(counts).map(([type, count], idx) => ({
      name: CONTRACT_LABELS[type] || type, // Use predefined label or fallback to type
      value: count,
      color: COLORS[idx % COLORS.length],
    }));
    
    return chartData.filter(d => d.value > 0);
  }, [buildingsData]);

  if (data.length === 0) {
    return (
      <Card className="arr-chart-card">
        <Card.Body>
          <h5 className="chart-title">Contract Type Distribution</h5>
          <div className="no-data-message">
            <p>No contract data available to display contract type distribution.</p>
          </div>
        </Card.Body>
      </Card>
    );
  }

  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {payload.map((entry, idx) => (
          <li key={`item-${idx}`} style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
            <span style={{ display: 'inline-block', width: 14, height: 14, background: entry.color, borderRadius: '50%', marginRight: 8 }}></span>
            <span style={{ fontWeight: 500 }}>{entry.value}: {entry.payload.value}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Card className="arr-chart-card">
      <Card.Body>
        <h5 className="chart-title">Contract Type Distribution</h5>
        <div className="chart-container" style={{ padding: '10px' }}>
          <ResponsiveContainer width="100%" height={350} className="no-focus-outline">
            <PieChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
              <Pie
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={2}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry, idx) => (
                  <Cell key={`cell-${idx}`} fill={entry.color} style={{ outline: 'none' }} />
                ))}
              </Pie>
              <Tooltip formatter={(value, name, props) => [`${value}`, `${props.payload.name}`]} />
              <Legend content={renderLegend} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ContractTypeDistribution; 